import { Subject } from 'rxjs';
import { LoggerService } from '../services/logger.service';
import { IKeyedCollection } from '../interfaces/utils/keyed-collection';

export class Dictionary<T> implements IKeyedCollection<T> {
  public onAdd: Subject<string>;
  public onRemove: Subject<string>;
  public onReplace: Subject<string>;
  private items: { [index: string]: T } = {};
  private count$ = 0;

  constructor() {
    this.onAdd = new Subject();
    this.onRemove = new Subject();
    this.onReplace = new Subject();
  }

  public containsKey(key: string): boolean {
    return this.items.hasOwnProperty(key);
  }

  public count(): number {
    return this.count$;
  }

  public add(key: string, value: T): void {
    if (!this.items.hasOwnProperty(key)) {
      this.count$++;
      this.items[key] = value;
      this.onAdd.next(key);
    }
  }

  public addOrReplace(key: string, value: T): void {
    if (!this.items.hasOwnProperty(key)) {
      this.count$++;
      this.items[key] = value;
      this.onAdd.next(key);
    } else {
      this.items[key] = value;
      this.onReplace.next(key);
    }
  }

  public remove(key: string): T {
    const val = this.items[key];
    delete this.items[key];
    this.count$--;
    this.onRemove.next(key);
    return val;
  }

  public item(key: string): T {
    if (key && typeof key === 'string') {
      if (this.containsKey(key)) {
        return this.items[key];
      } else {
        // TODO Código de error
        LoggerService.error('THERE_IS_NO_ELEMENT_WITH_KEY', key);
        return null;
      }
    } else {
      // TODO Código de error
      throw {
        message: 'INVALID_VALUE',
      };
    }
  }

  public keys(): string[] {
    const keySet: string[] = [];
    for (let prop in this.items) {
      if (this.items.hasOwnProperty(prop)) {
        keySet.push(prop);
      }
    }
    return keySet;
  }

  public values(): T[] {
    const values: T[] = [];
    for (let prop in this.items) {
      if (this.items.hasOwnProperty(prop)) {
        values.push(this.items[prop]);
      }
    }
    return values;
  }
}